export default {
  depName: function (DepCode, Deps) {
    if (Deps !== undefined && DepCode && Deps) {
      return Deps.filter(f => {
        if (DepCode.trim().includes(f.DepCode)) return DepCode.trim().includes(f.DepCode)
      }).map(function (elem) {
        return elem.DepName.split(' ')[0]
      }).join(', ')
    } else {
      return ''
    }
  },
  empPRCode: function (EmpCode, Persons, prefix = '') {
    if (Persons !== undefined && EmpCode && Persons) {
      return Persons.filter(f => {
        if (EmpCode.trim().includes(f.EmpCode)) return EmpCode.trim().includes(f.EmpCode)
      }).map(function (elem) {
        return prefix + elem.PRCode
      }).join(', ')
    } else {
      return ''
    }
  },
  empName: function (EmpCode, Persons, prefix = 'คุณ') {
    if (Persons !== undefined && EmpCode && Persons) {
      let empInput = EmpCode.trim().split(',')
      let index
      if (empInput.length > 1) {
        return empInput.reduce((pre, cur, id) => {
          if (id === 1) {
            index = Persons.findIndex(s => s.EmpCode === pre)
            if (index >= 0) {
              pre = prefix + Persons[index].EmpName.split(' ')[0]
            }
          }
          index = Persons.findIndex(s => s.EmpCode === cur)
          // console.log(index+' '+ id,pre , cur)
          if (index >= 0) {
            return pre += ',' + prefix + Persons[index].EmpName.split(' ')[0]
          } else {
            return pre
          }
        })
      } else {
        EmpCode = EmpCode.trim()
        index = Persons.findIndex(s => s.EmpCode === EmpCode)
        if (index >= 0) {
          return prefix + Persons[index].EmpName.split(' ')[0]
        } else {
          return EmpCode
        }
      }

      // return Persons.filter(f => {
      //   if (EmpCode.trim().includes(f.EmpCode)) return EmpCode.trim().includes(f.EmpCode)
      // }).map(function(elem) {
      //   return prefix + elem.EmpName.split(' ')[0]
      // }).join(', ')
    } else {
      return ''
    }
  },
  empEmail: function (EmpCode, Persons, replaceText = '@thaiauto.or.th') {
    if (Persons !== undefined && EmpCode && Persons) {
      let empInput = EmpCode.trim().split(',')
      let index
      if (empInput.length > 1) {
        return empInput.reduce((pre, cur, id) => {
          if (id === 1) {
            index = Persons.findIndex(s => s.EmpCode === pre)
            if (index >= 0) {
              pre = Persons[index].Email.replace('@thaiauto.or.th', replaceText)
            }
          }
          index = Persons.findIndex(s => s.EmpCode === cur)
          // console.log(index+' '+ id,pre , cur)
          if (index >= 0) {
            return pre += ',' + Persons[index].Email.replace('@thaiauto.or.th', replaceText)
          } else {
            return pre
          }
        })
      } else {
        EmpCode = EmpCode.trim()
        index = Persons.findIndex(s => s.EmpCode === EmpCode)
        if (index >= 0) {
          return Persons[index].Email.replace('@thaiauto.or.th', replaceText)
        } else {
          return EmpCode
        }
      }

      // return Persons.filter(f => {
      //   if (EmpCode.trim().includes(f.EmpCode)) return EmpCode.trim().includes(f.EmpCode)
      // }).map(function(elem) {
      //   return prefix + elem.EmpName.split(' ')[0]
      // }).join(', ')
    } else {
      return ''
    }
  },
  empFullName: function (EmpCode, Persons, prefix = 'คุณ') {
    if (Persons !== undefined && EmpCode && Persons) {
      let empInput = EmpCode.trim().split(',')
      let index
      if (empInput.length > 1) {
        return empInput.reduce((pre, cur, id) => {
          if (id === 1) {
            index = Persons.findIndex(s => s.EmpCode === pre)
            if (index >= 0) {
              pre = prefix + Persons[index].EmpName
            }
          }
          index = Persons.findIndex(s => s.EmpCode === cur)
          // console.log(index+' '+ id,pre , cur)
          if (index >= 0) {
            return pre += ',' + prefix + Persons[index].EmpName
          } else {
            return pre
          }
        })
      } else {
        EmpCode = EmpCode.trim()
        index = Persons.findIndex(s => s.EmpCode === EmpCode)
        if (index >= 0) {
          return prefix + Persons[index].EmpName
        } else {
          return EmpCode
        }
      }
      // return Persons.filter(f => {
      //   if (EmpCode.trim().includes(f.EmpCode)) return EmpCode.trim().includes(f.EmpCode)
      // }).map(function(elem) {
      //   return prefix + elem.EmpName
      // }).join(', ')
    } else {
      return ''
    }
  }
}
